import { render, staticRenderFns } from "./uploadPMP.template.vue?vue&type=template&id=770b4f04&scoped=true&"
var script = {}
import style0 from "./uploadPMP.template.vue?vue&type=style&index=0&id=770b4f04&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "770b4f04",
  null
  
)

export default component.exports